import { render } from "./VerticalSeparator.vue?vue&type=template&id=77eec552"
const script = {}

import "./VerticalSeparator.vue?vue&type=style&index=0&id=77eec552&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__